import axios from "../../../axios"
import {getCurrentTenant, parseObjectParamsToString, parseParamToString} from '@/utils'

export default {
  fetch(searchParams) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          instances ${parseObjectParamsToString(searchParams)} {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            reset_finished,
            phone_number,
            qr_code,
            waba_id,
            nickname,
            color,
            is_official,
            official_token,
            messaging_send,
            messaging_limit,
            official_phone_id,
            integration_id
          }
        }
      `
    })
  },
  add(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createInstance (
            name: "${instance.name}",
            hub_host: "${instance.hub_host}"
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            reset_finished,
            phone_number,
            is_official,
            waba_id,
            nickname,
            color,
            official_token,
            official_phone_id,
            integration_id
          }
        }
      `
    })
  },
  update(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateInstance (
            id: ${instance.id},
            `+ (instance.name != null ? `name: "${instance.name}",` : '') + `,
            `+ (instance.color != null ? `color: "${instance.color}",` : '') + `,
            `+ (instance.broker != null ? `broker: "${instance.broker}",` : '') + `,
            `+ (instance.waba_id != null ? `waba_id: "${instance.waba_id}",` : '') + `,
            `+ (instance.nickname != null ? `nickname: "${instance.nickname}",` : '') + `,
            `+ (instance.hub_host != null ? `hub_host: "${instance.hub_host}",` : '') + `,
            `+ (instance.phone_number != null ? `phone_number: "${instance.phone_number}",` : '') + `,
            `+ (instance.official_token != null ? `official_token: "${instance.official_token}",` : '') + `,
            `+ (instance.messaging_send != null ? `messaging_send: "${instance.messaging_send}",` : '') + `,
            `+ (instance.messaging_limit != null ? `messaging_limit: "${instance.messaging_limit}",` : '') + `,
            `+ (instance.official_phone_id != null ? `official_phone_id: "${instance.official_phone_id}",` : '') + `,
            `+ (instance.dialog_params != null ? `dialog_params: ${parseObjectParamsToString(instance.dialog_params, false)},` : '') + `
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            reset_finished,
            phone_number,
            is_official,
            waba_id,
            nickname,
            color,
            official_token,
            official_phone_id,
            integration_id
          }
        }
      `
    })
  },
  updatePhoneNumber(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateInstance (
            id: ${instance.id},
            phone_number: "${instance.phone_number}"
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            reset_finished,
            phone_number,
            is_official,
            waba_id,
            nickname,
            color,
            official_token,
            official_phone_id,
            integration_id
          }
        }
      `
    })
  },
  updateByIntegration(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateInstanceIntegration (
            id: ${instance.id},
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            reset_finished,
            phone_number,
            is_official,
            waba_id,
            nickname,
            color,
            official_token,
            official_phone_id,
            integration_id
          }
        }
      `
    })
  },
  delete(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteInstance (
            id: ${instanceId}
          )
        }
      `
    })
  },
  restartInstancePlugin(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          restartInstancePlugin (
            id: ${instanceId}
          )
        }
      `
    })
  }
}

